import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-add-ship-review',
  templateUrl: './add-ship-review.component.html',
  styleUrls: ['./add-ship-review.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddShipReviewComponent implements OnInit {

  shipName:string;
  shipCode:string;
  shipPoool:string;
  shipOwner:string;
  shipClass:string;
  effectiveDate:any;
  isScrubber:boolean = false;
  isLng:boolean = false;
  poolPoints:string;
  scrubberPoints:string;
  dateStatus:boolean = false;
  mySubscription: Subscription;
  constructor( private _vesselService: VesselsService,private datePipe: DatePipe,
    private toasterService: ToasterService,) {
  }

  ngOnInit() {
    console.log(this._vesselService.addShipfilterval)
    console.log(this._vesselService.addSubpoolfilterval)
    console.log(this._vesselService.addShipdateselected)
    console.log(this._vesselService.serachShipData)
    console.log("sc",this._vesselService.scrubberToggleval)
    console.log("lng",this._vesselService.lngToggleval)
    console.log("lng val",this._vesselService.pointsVal)
    console.log("sc val",this._vesselService.scrubberPointsval)
    this.shipName = this._vesselService.serachShipData[0]?.vslName;
    this.shipCode = this._vesselService.serachShipData[0]?.vslCode;
    this.shipPoool = this._vesselService.addSubpoolfilterval;
    this.shipOwner = this._vesselService.addShipfilterval?.selectedRecords?.name;
    this.shipClass = this._vesselService.serachShipData[0]?.vslClass;
    this.effectiveDate = this._vesselService.addShipdateselected;
    this.isScrubber = this._vesselService.scrubberToggleval;
    console.log(this.isScrubber)
    this.isLng = this._vesselService.lngToggleval;
    this.poolPoints = this._vesselService.pointsVal?.points;
    this.scrubberPoints = this._vesselService.scrubberPointsval?.scrubberPoints;
    this.dateStatus =  this._vesselService.showDatestatus;
    console.log(this._vesselService.callSubmitship)
    this.mySubscription = this._vesselService.callSubmitship.subscribe((res:any)=>{
      if(res){
        this.sumbitMethod();
        this._vesselService.serachShipData = [];
        // this._vesselService.addSubpoolfilterval = '';
        this._vesselService.addShipfilterval = {};
        this._vesselService.addShipdateselected = '';
        this._vesselService.scrubberToggleval = false;
        this._vesselService.lngToggleval = false;
        this._vesselService.pointsVal.points = '';
        this._vesselService.scrubberPointsval.scrubberPoints = '';
        // this.dateStatus = false;
      }
    })
    
  }

  sumbitMethod(){
   
    let data = {
      "fleet": this._vesselService.getFleetval,
      "shipId": this._vesselService.serachShipData[0]?.vslNumber,
      "poolId": this._vesselService.addSubpoolfilterval,
      "ownerId": this._vesselService.addShipfilterval?.selectedRecords?.id,
      "effectiveActivationDate": this.datePipe.transform(this.effectiveDate,"yyyy-MM-dd"),
      "scrubberUsage": this._vesselService.scrubberToggleval,
      "lngUsage": this._vesselService.lngToggleval,
      "poolPoints": Number(this._vesselService.pointsVal?.points),
      "scrubberPoints": Number(this._vesselService.scrubberPointsval?.scrubberPoints)
    }
    console.log(data)
   
    this._vesselService.addShipsubmit(data).subscribe({
      next:(res:any)=>{
        if(res?.data?.addShipToFleet?.success){
          console.log(res)
          this.toasterService.openToast('Success', res?.data?.addShipToFleet?.message);
          this._vesselService.navigateFleetlist.next(true);
          this._vesselService.callSubmitship.next(false);
        
        }else{
          this.toasterService.openToast('Warning', res?.data?.addShipToFleet?.message);
          this._vesselService.navigateFleetlist.next(true);
          this._vesselService.callSubmitship.next(false);
      
        }
      },
      error:(error: any)=>{
        console.log(error)
        this.toasterService.openToast('Error', error);
        this._vesselService.navigateFleetlist.next(true); 
        this._vesselService.callSubmitship.next(false);
          
      }
    })
      
  }

 ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
  
}